export default __webpack_public_path__ + "static/media/ilustracao-homem-e-mulher-titularidade.d25d8e80.svg";